import { get } from 'lodash/fp';
import { createSelector } from 'reselect';
import { composeProps, createPropsExtender } from '@mews/framework';
import { getStringProp } from '@mews/fp';
import { getServiceOrder } from '../ducks/serviceOrders';

export const getServiceOrderIdFromProps = getStringProp('serviceOrderId');

export const getServiceOrderServiceId = createSelector(
    composeProps(getServiceOrder, createPropsExtender('id', getServiceOrderIdFromProps)),
    (serviceOrder) => get('serviceId', serviceOrder)
);
